import { O as l, E as r, T as c } from "./legend-Brmz23h1-DXBrijlc.js";
import "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { d as s } from "./unsafe-svg-LX0N8ZFI-BwyM0GGP.js";
import { c as L } from "./legend-circle-C5ycoo5C-z9VTkpyO.js";
var n = /* @__PURE__ */ ((e) => (e.CIRCLE = "circle", e.TRIANGLE = "triangle", e.SQUARE = "square", e.DIAMOND = "diamond", e.TRIANGLE_DOWN = "triangle-down", e))(n || {});
const m = " ";
function f(e, t = m) {
  return typeof t != "string" && (t = m), e == null ? void 0 : e.split(t).map((i) => i.trim());
}
const p = {
  seriesName: "series",
  beaconLegendName: "beacon-legend",
  beaconLegendItemName: "beacon-legend-item",
  beaconTableName: "beacon-table",
  deselectedClassName: "deselected",
  pointActiveState: "normal",
  pointInactiveState: "inactive",
  beaconNestedComponents: ["beacon-legend", "beacon-legend-item", "beacon-table", "beacon-chart-tooltip"],
  highchartsASTTags: ["beacon-chart-tooltip", "beacon-chart-tooltip-data"],
  highchartsASTAttributes: ["label", "value", "index", "color", "subset", "variant", "uuid", "tooltip-title", "disable-title"],
  defaultLegendLayout: {
    vertical: l.TOP,
    horizontal: r.CENTER,
    direction: c.HORIZONTAL
  },
  exportMenuItems: ["viewFullscreen", "printChart", "separator", "separator", "downloadCSV"],
  // Conditional export menu item when charts don't have an HTML table already.
  exportMenuViewDataLabel: "viewData",
  // Because CDT tokens do not translate to JS tokens, these are defined on their own
  titleSpacers: {
    small: 16,
    large: 24
  },
  decimalNumber: 10,
  captionMargin: 24
}, x = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="2" />
</svg>
`, N = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="6" />
</svg>
`, E = `<svg slot="icon" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="fallback-icon">
    <rect y="5" width="7.0711" height="7.0711" transform="rotate(-45 0 5)"/>
</svg>`, O = `<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect y="5" width="7" height="7" transform="rotate(-45 0 5)"/>
</svg>
`, T = `<svg slot="icon" height="10px" width="10px" viewbox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="fallback-icon">
    <rect width="10" height="10"/>
</svg>`, A = `<svg height="10" width="10" viewbox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect width="10" height="10"/>
</svg>
`, D = `<svg slot="icon" width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="fallback-icon">
    <path d="M0 8L5 0L10 8H0Z"/>
</svg>`, I = `<svg slot="icon" width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="fallback-icon">
    <path d="M10 0L5 8L6.99382e-07 -8.74228e-07L10 0Z"/>
</svg>`, R = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M10 0L5 8L6.99382e-07 -8.74228e-07L10 0Z"/>
</svg>
`, _ = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M0 8L5 0L10 8H0Z"/>
</svg>
`, o = {
  circle: s(L),
  triangle: s(D),
  square: s(T),
  diamond: s(E),
  triangleDown: s(I)
}, a = {
  multiLevel: x,
  circle: N,
  triangle: _,
  square: A,
  diamond: O,
  triangleDown: R
};
function k(e) {
  if (!e)
    return p.defaultLegendLayout;
  const t = f(e);
  return t ? {
    vertical: t.find((i) => Object.values(l).includes(i)) || l.TOP,
    horizontal: t.find((i) => Object.values(r).includes(i)) || r.CENTER,
    direction: t.find((i) => Object.values(c).includes(i)) || c.HORIZONTAL
  } : p.defaultLegendLayout;
}
function q() {
  const e = this.dataTableDiv.querySelector("table");
  if (!e)
    return;
  const t = document.createElement(this.userOptions.plotOptions.custom.tableElement);
  this.dataTableDiv.appendChild(t), t.appendChild(e);
}
function b(e) {
  const t = [...Object.values(n)], i = e % t.length;
  return t[i];
}
function B(e) {
  switch (b(e)) {
    case n.CIRCLE:
      return o.circle;
    case n.TRIANGLE:
      return o.triangle;
    case n.SQUARE:
      return o.square;
    case n.DIAMOND:
      return o.diamond;
    case n.TRIANGLE_DOWN:
      return o.triangleDown;
    default:
      return o.circle;
  }
}
function G(e, t) {
  if (t)
    return a.multiLevel;
  switch (b(e)) {
    case n.CIRCLE:
      return a.circle;
    case n.TRIANGLE:
      return a.triangle;
    case n.SQUARE:
      return a.square;
    case n.DIAMOND:
      return a.diamond;
    case n.TRIANGLE_DOWN:
      return a.triangleDown;
    default:
      return a.circle;
  }
}
function Z(e) {
  var t, i, g, d, h, w;
  if (e.series.length >= 2) {
    const u = (g = (i = (t = e.series[0]) == null ? void 0 : t.points[0]) == null ? void 0 : i.graphic) == null ? void 0 : g.symbolName, v = (w = (h = (d = e.series[1]) == null ? void 0 : d.points[0]) == null ? void 0 : h.graphic) == null ? void 0 : w.symbolName;
    return u && v ? u !== v : !0;
  }
  return !1;
}
export {
  G as B,
  q as G,
  k as M,
  p as b,
  f,
  n as i,
  Z as k,
  B as q
};
